import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid/v4';

import GenericButton from '../common/GenericButton';

import * as quickReportsActions from '../../actions/quickReportsActions';

class QuickReportsDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibility: false,
      x: 0,
      y: 0,
      title: '',
      report: '',
      detailGroups: {},
      subDropdown: [],
      initialized: false,
      showCombineWith: false,
      showDrilldown: false,
      showRename: false,
      chartType: 'normal',
    };
  }

  getStyles = () => ({
    minWidth: '120px',
    minHeight: '100px',
    height: 'auto',
    width: 'auto',
    border: '1px solid RGB(71, 100, 138)',
    position: 'absolute',
    left: this.state.x,
    top: this.state.y,
    display: this.state.visibility ? 'block' : 'none',
    backgroundColor: '#fff',
  });

  setCoordinates = (
    event,
    obj,
    detailGroups,
    subDropdown,
    labels,
    removeBar,
    toggleIcon,
    combineWith,
    drilldown,
    renameLabel,
    chartType,
  ) => {
    this.setState({
      x: event.offsetX,
      y: event.pageY - 140,
      visibility: true,
      title: obj.category,
      subCategory: obj.series.name,
      detailGroups,
      subDropdown,
      labels,
      chartType,
      drilldown,
    });
    if (!this.state.initialized) {
      this.initialize(removeBar, toggleIcon, combineWith, renameLabel);
    }
  };

  processLabel = () => {
    if (this.state.chartType === 'normal') {
      return this.state.labels ? this.state.labels[this.state.title] : null;
    }
    return this.state.title;
  };

  initialize = (removeBar, toggleIcon, combineWith, renameLabel) => {
    this.setState({
      removeBar,
      toggleIcon,
      combineWith,
      renameLabel,
      initialized: true,
    });
  };

  toggleVisibility = visible => {
    this.setState({
      visibility: visible || !this.state.visibility,
      showCombineWith: false,
      showDrilldown: false,
      showRename: false,
    });
  };

  renderLabels = () =>
    this.state.labels
      .filter(label => label !== this.processLabel())
      .map(label => (
        <p
          key={uuid()}
          onClick={() => {
            this.state.combineWith(
              this.state.subCategory,
              this.state.chartType === 'normal'
                ? this.state.labels[this.state.title]
                : this.state.title,
              label,
            );
            this.toggleVisibility();
          }}
        >
          {label}
        </p>
      ));

  renderDrilldown = () =>
    this.state.subDropdown.map(({ key }) => (
      <p
        key={uuid()}
        onClick={() => {
          this.state.drilldown(key);
          this.toggleVisibility();
        }}
      >
        {key}
      </p>
    ));

  renderRename = () => (
    <div className="rename-dropdown">
      <input
        type="text"
        onChange={e => this.setState({ renamedLabel: e.target.value })}
      />
      <GenericButton
        name="Apply Rename"
        btnStyle="button btn-rename"
        onBtnClick={() => {
          this.state.renameLabel(
            this.state.chartType === 'normal'
              ? this.state.labels[this.state.title]
              : this.state.title,
            this.state.renamedLabel,
          );
          this.toggleVisibility();
        }}
      />
      <br />
    </div>
  );

  render() {
    return (
      <div>
        <div className="quick-reports-dropdown" style={this.getStyles()}>
          <p>{this.processLabel()}</p>
          <GenericButton
            name="Remove"
            btnStyle="button"
            onBtnClick={() => {
              this.state.removeBar(
                this.state.chartType === 'normal'
                  ? this.state.labels[this.state.title]
                  : this.state.title,
              );
              this.toggleVisibility();
            }}
          />
          <br />
          {this.state.labels ? (
            <GenericButton
              name={`${
                this.state.showCombineWith
                  ? String.fromCharCode(9660)
                  : String.fromCharCode(9654)
              } Combine With`}
              btnStyle={`button ${this.state.showCombineWith ? 'active' : ''}`}
              onBtnClick={() => {
                this.setState({ showCombineWith: !this.state.showCombineWith });
              }}
            />
          ) : null}
          <br />
          <div className="combine-with-list">
            {this.state.showCombineWith ? this.renderLabels() : null}
          </div>
          {this.state.chartType !== 'normal' ? (
            <div>
              <GenericButton
                name={`${
                  this.state.showDrilldown
                    ? String.fromCharCode(9660)
                    : String.fromCharCode(9654)
                } Drilldown to`}
                btnStyle={`button ${this.state.showDrilldown ? 'active' : ''}`}
                onBtnClick={() => {
                  this.setState({ showDrilldown: !this.state.showDrilldown });
                }}
              />
              <br />
            </div>
          ) : null}
          <div className="drill-down-list">
            {this.state.showDrilldown ? this.renderDrilldown() : null}
          </div>
          <GenericButton
            name={`${
              this.state.showRename
                ? String.fromCharCode(9660)
                : String.fromCharCode(9654)
            } Rename`}
            btnStyle={`button ${this.state.showRename ? 'active' : ''}`}
            onBtnClick={() => {
              this.setState({ showRename: !this.state.showRename });
            }}
          />
          <br />
          {this.state.showRename ? this.renderRename() : null}
          <GenericButton
            name="Toggle Icon"
            btnStyle="button"
            onBtnClick={() => {
              this.state.toggleIcon(
                this.state.chartType === 'normal'
                  ? this.state.labels[this.state.title]
                  : this.state.title,
              );
              this.toggleVisibility();
            }}
          />
          <br />
          <GenericButton
            name=""
            btnStyle="btn-close"
            onBtnClick={() => this.toggleVisibility()}
          />
        </div>
      </div>
    );
  }
}

QuickReportsDropdown.propTypes = {};

function mapDispatchToProps(dispatch) {
  return {
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(QuickReportsDropdown);
